"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2979],{

/***/ 42979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(48228);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_property_card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39470);
/* harmony import */ var _components_custom_carrusel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20518);
/* harmony import */ var _components_skeletons_property_collector_card_skeleton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58254);
/* harmony import */ var api_realestate_request__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13897);
/* harmony import */ var custom_hooks_useGetPersintParamas_hook__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53541);
/* harmony import */ var custom_hooks_useWindowsSize_hook__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51860);
/* harmony import */ var shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1283);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70917);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













function PropertiesSlider(props) {
  var size = (0,custom_hooks_useWindowsSize_hook__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
  var width = size === null || size === void 0 ? void 0 : size.width;
  var ref = (0,custom_hooks_useGetPersintParamas_hook__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();

  var fetchProjectSlider = /*#__PURE__*/function () {
    var _ref = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
      var response;
      return _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,api_realestate_request__WEBPACK_IMPORTED_MODULE_8__/* .getRealestate */ ._G)(_objectSpread({
                page: 1
              }, props.filters));

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchProjectSlider() {
      return _ref.apply(this, arguments);
    };
  }();

  var _useMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_13__/* .useMutation */ .D)([props.refRequest], fetchProjectSlider, {}),
      data = _useMutation.data,
      status = _useMutation.status,
      mutate = _useMutation.mutate;

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    mutate();
  }, []);

  if (status === "loading") {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(Section, {
      title: props.title,
      subtitle: props.subtitle
    }, []);
  }

  if ((data === null || data === void 0 ? void 0 : data.data.length) == 0) {
    var _props$withoutResults;

    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, (_props$withoutResults = props.withoutResultsComponent) !== null && _props$withoutResults !== void 0 ? _props$withoutResults : []);
  }

  if (status === "error") {
    return null;
  }

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(Section, {
    title: props.title,
    subtitle: props.subtitle
  }, data === null || data === void 0 ? void 0 : data.data.map(function (property, i) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
      key: i,
      href: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_11__/* .CPagesPath.es.property_detail */ .K.es.property_detail(property) + ref,
      passHref: true
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(CardWrapper, {
      key: i,
      target: width > 991 ? "_blank" : "",
      rel: "nofollow noopener noreferrer"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_property_card__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, property)));
  })), props.children);
}

var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("section",  true ? {
  target: "e1v6rvz43"
} : 0)( true ? {
  name: "182gzjg",
  styles: "width:100%;padding:50px 0;margin-bottom:50px;@media screen and (max-width: 991px){margin-bottom:0;padding:20px 0;}"
} : 0);

var CardWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("a",  true ? {
  target: "e1v6rvz42"
} : 0)( true ? {
  name: "1y754dr",
  styles: "display:flex;justify-content:center;width:100%;position:relative;overflow:hidden;&::after{content:\"\";position:absolute;bottom:0;left:0;right:0;height:30%;background:linear-gradient(\n      to top,\n      rgba(255, 255, 255, 0.8) 0%,\n      transparent 100%\n    );pointer-events:none;z-index:1;}"
} : 0);

var Title = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h2",  true ? {
  target: "e1v6rvz41"
} : 0)( true ? {
  name: "1yse9on",
  styles: "width:100%;text-align:center;text-transform:uppercase;font-size:1.9rem;margin-bottom:20px;color:var(--color-brand-blue-main);margin-top:50px"
} : 0);

var TitleSpan = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1v6rvz40"
} : 0)( true ? {
  name: "1a0w822",
  styles: "font-weight:300"
} : 0);

/* harmony default export */ __webpack_exports__["Z"] = (PropertiesSlider);

function Section(props) {
  var children = props.children,
      subtitle = props.subtitle,
      title = props.title;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(Wrapper, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("div", {
    className: "container"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(Title, null, title, " ", (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(TitleSpan, null, subtitle)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_custom_carrusel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    enablePlaceholder: true,
    placeholderItem: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_skeletons_property_collector_card_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, null),
    numberOfPlaceholderItems: 4
  }, children)));
}

/***/ }),

/***/ 58254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86886);
/* harmony import */ var _mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88078);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);





function PropertyCardCollectionSkeleton() {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    container: true,
    flexDirection: "column"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    variant: "rectangular",
    width: 300,
    height: 140,
    style: {
      borderRadius: 10
    }
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    container: true,
    marginBottom: 1
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "68%",
    height: 40
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "80%",
    height: 20
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "50%",
    height: 30
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "80%",
    height: 30
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "80%",
    height: 30
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (PropertyCardCollectionSkeleton);

/***/ })

}]);